<template>
  <div class="invite-wrap">
    <div class="banner" :style="`background-image: url(${bgImg})`">
      <!-- <img :src="bgImg" alt="invite-friends-bg"> -->
      <div class="invite-banner-content">
        <div class="invite-title">{{ $t('labels.acc.invite.desc1') }}</div>
        <!-- <div class="invite-sub-title">{{ $t('labels.acc.invite.desc2') }}</div> -->
      </div>
    </div>
    <div class="main-container">
      <div class="overflow-hidden">
        <ul class="invite-step row gutter-sm">
          <div class="py-2 col-xs-12 col-sm-12 col-md-12 col-lg-4">
            <li>
              <div class="invite-step-index">1</div>
              <div class="invite-step-content">
                <div class="invite-step-title">{{ $t('labels.acc.invite.step1.desc1') }}</div>
                <div class="invite-step-desc">{{ $t('labels.acc.invite.step1.desc2') }}</div>
              </div>
            </li>
          </div>

          <div class="py-2 col-xs-12 col-sm-12 col-md-12 col-lg-4">
            <li>
              <div class="invite-step-index">2</div>
              <div class="invite-step-content">
                <div class="invite-step-title">{{ $t('labels.acc.invite.step2.desc1') }}</div>
                <div class="invite-step-desc">{{ $t('labels.acc.invite.step2.desc2') }}</div>
              </div>
            </li>
          </div>

          <div class="py-2 col-xs-12 col-sm-12 col-md-4-12 col-lg-4">
            <li>
              <div class="invite-step-index">3</div>
              <div class="invite-step-content">
                <div class="invite-step-title">{{ $t('labels.acc.invite.step3.desc1') }}</div>
                <div class="invite-step-desc">{{ $t('labels.acc.invite.step3.desc2') }}</div>
              </div>
            </li>
          </div>
        </ul>
      </div>

      <div class="labelInexchangable invite-share-title" style="color:red">* {{ $t('labels.acc.invite.inexchangabledesc') }}</div>
      <div v-if="showInviteSection" class="invite-share mb-40">
        <div class="invite-share-title">{{ $t('labels.acc.invite.enterCode') }}</div>
        <div class="invite-share-content">
          <div>
            <div class="invite-share-inner-title">{{ $t('labels.acc.invite.code') }}</div>
            <div class="add-referral-row items-center d-flex flex-column flex-sm-row">
              <div class="add-referral" :class="$vuetify.breakpoint.xsOnly ? 'mr-0 mb-1' : 'mr-4'">
                <input :disabled="referralSet" type="text" v-model="referralCode" />
              </div>
              <span class="align-self-end" v-if="!referralSet" @click="setReferral">{{ $t('labels.add') }}</span>
            </div>
            <!--<span
              v-if="!referralSet"
              class="invite-no-referral"
              @click="showConfirmModal"
            >{{ $t('labels.acc.invite.noReferral') }}<  /span>-->
          </div>
        </div>
      </div>

      <div v-if="showShareSection" class="invite-share">
        <div class="invite-share-title">{{ $t('labels.acc.invite.mySharing') }}</div>
        <div class="invite-share-content">
          <div class="invite-code-column">
            <div class="invite-share-inner-title">{{ $t('labels.acc.invite.registerLink') }}</div>
            <CopyText class="mb-25" :text="inviteUrl"></CopyText>
            <!--<div class="drop-qr-code">
              <div v-for="item in 2" :key="item">
                <img src="" alt="">
                <div>
                  <div ref="rqCodes"></div>
                  <span>扫码分享</span>
                </div>
              </div>
            </div>-->
            <div class="invite-code-box">
              <div class="invite-code-field">
                <div class="invite-share-inner-title">{{ $t('labels.acc.invite.code') }}</div>
                <CopyText :text="Getter_User_Info.invite || inviteCode"></CopyText>
              </div>
              <div class="invite-qrcode-wrap">
                <div class="invite-share-inner-title">{{ $t('labels.acc.invite.qrCode') }}</div>
                <div class="invite-qrcode-content" :class="{ 'mx-auto': $vuetify.breakpoint.xsOnly }">
                  <div class="qr-code">
                    <!--<span ref="QrCode"></span>-->
                    <div class="qrcode-box" id="qrcodeBox">
                      <v-progress-circular
                        v-if="!inviteUrl"
                        :size="50"
                        color="primary"
                        width="2"
                        indeterminate
                      ></v-progress-circular>
                      <QrCode v-else ref="qrcodeCom" :text="inviteUrl" :qrWidth="'150'"></QrCode>
                    </div>
                  </div>
                  <div class="download-btn" @click="downloadQRCodeImg">{{ $t('labels.acc.invite.download.qrCode') }}</div>
                </div>
              </div>
            </div>
          </div>

          <!-- <div>
            <div class="invite-share-inner-title">{{ $t('labels.acc.invite.registerTotal') }}</div>
            <div>{{referralPersonsData.total > -1 ? referralPersonsData.total : '--'}}</div>
          </div>
          <div>
            <div class="invite-share-inner-title">{{ $t('labels.acc.invite.kycTotal') }}</div>
            <div>{{referralPersonsData.kycCount > -1 ? referralPersonsData.kycCount : '--'}}</div>
          </div>-->
        </div>
      </div>

      <GCToCTable :config="config" class="market-content">
        <div class="market-forms" slot="title-right">
          <!-- <span><input type="text" placeholder="Pair"></span> -->
        </div>
        <template slot-scope="{ data }">
          <div class="tmpl">
            <div v-if="data.col.key === 'id'" class="light">GRX{{ data.conf.id }}</div>
            <div v-if="data.col.key === 'usrLogin'" class="light">{{ data.conf.usrLogin }}</div>
            <div v-if="data.col.key === 'created'" class="light">{{ setTimeZone(data.conf.created, 'YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD')}}</div>
            <!-- <div v-if="data.col.key === 'status'" class="light">
            {{data.conf.status}}-->
            <!-- <span :class="data.conf.kycStatus === 1 ? 'has-realnamed' : 'not-realname'">{{kycStatusText[data.conf.kycStatus]}}</span> -->
            <!-- </div> -->
          </div>
        </template>
      </GCToCTable>
      <div class="referral-list-pagination" v-if="pageData.pages > 1">
        <!-- <q-pagination
          v-model="pageData.current"
          :direction-links="true"
          :max-pages="7"
          :max="pageData.total"
          @input="getMyReferralData"
        /> -->

        <v-pagination v-model="pageData.current" :length="pageData.total" @input="getMyReferralData"></v-pagination>
      </div>

      <!-- <article class="invite-rule">
        <h6 class="rule-title">{{ $t('labels.acc.invite.activityDetail') }}</h6>
        <div class="article-content" v-html="referralRules.activityContent"></div>

      </article>-->
    </div>
    <!-- <ConfirmModal
      @submit="setCompanyAsReferral"
      :show.sync="confirmModalShow"
      :content="$t('labels.acc.invite.noReferral.confirm')"
    /> -->
  </div>
</template>
<script>
import CopyText from './CopyText.vue';
// import QRCode from 'qrcodejs2';
import QrCode from '@/components/QrCode/QrCode';
import GCToCTable from '../../components/GCToCTable';
import tool from '../../common/js/tool';
import { accountManagementApi } from '../../api/user/accountManagementApi';
import { actionTypes } from '@/store/action-types';
import { mapGetters, mapActions } from 'vuex';
// import ConfirmModal from '@/components/confirm-modal/ConfirmModal';

export default {
  name: 'Invite',
  components: { CopyText, GCToCTable, QrCode },
  data() {
    return {
      gg: false,
      confirmModalShow: false,
      qrCodeText: '456123',
      baseUrl: tool.getBaseUrl(),
      inviteUrl: '',
      inviteCode: '',
      bgImg: require('@/assets/images/invite_bg.png'),
      referralRules: {},
      referralPersonsData: {
        kycCount: null, //  实名人数
        total: null // 总人数
      },
      pageData: {
        current: 1,
        size: 10,
        total: 0,
        pages: 0
      },
      config: {
        // tabList: [{ name: '邀请记录', value: 'inviteHistory' }],
        tabList: [{ name: this.$t('labels.acc.invite.history'), value: 'inviteHistory' }],
        currentTab: 'inviteHistory',
        tableHeads: [
          { key: 'id', name: this.$t('labels.uid'), sort: false, sortType: '', flex: '2 2 0' },
          { key: 'usrLogin', name: this.$t('labels.acc.invite.downlineAcc'), sort: false, sortType: '', flex: '2 2 0' },
          { key: 'created', name: this.$t('labels.joinDate'), sort: false, sortType: '', flex: '1 1 0' }
          // { key: 'status', name: this.$t('labels.status'), sort: false, sortType: '', flex: '1 1 0' },
        ],
        dataList: []
      },
      referralCode: '', // Set referral
      referralSet: false,
      showInviteSection: true,
      showShareSection: true
    };
  },
  methods: {
    ...mapActions([actionTypes.GET_USERINFO_ACTION]),
    // drawQrCode () {
    //   const ref = this.$refs.QrCode;
    //   const refs = this.$refs.rqCodes;
    //   this.draw(ref);
    //   this.draw(refs[0]);
    //   this.draw(refs[1]);
    // },
    // draw (ref) {
    //   if (ref) {
    //     ref.innerHTML = '';
    //     const qrCode = new QRCode(ref, {
    //       text: this.qrCodeText,
    //       width: 124,
    //       height: 124,
    //       colorDark: '#000000', // 显示颜色
    //       colorLight: '#ffffff', // 背景颜色
    //       correctLevel: QRCode.CorrectLevel.H, // 质量高度
    //     });
    //   }
    // },
    getMyReferralCode() {
      accountManagementApi
        .getMyReferralCode()
        .then(res => {
          const referralCode = res.data.referral; // my upline
          if (referralCode) {
            this.referralCode = referralCode;
            this.referralSet = true;
            this.showShareSection = true; // Show share section if user already set referrer
          } else if (referralCode === '' /* empty string = referer is company */) {
            this.referralSet = true;
            this.showInviteSection = false; // Hide invite section if the referer is company
            this.showShareSection = true; // Show share section if user already set referrer
          } else if (referralCode === null /* Not yet set referrer */) {
            this.referralSet = false;
            // this.showShareSection = false; // Hide share section if user has not set referrer yet
          }
          this.inviteCode = res.data.invite;
        })
        .catch(() => {});
    },
    setReferral() {
      if (!this.referralCode) {
        this.errorNotify(this.$t('v.common.invite'));
        return;
      }
      const data = {
        refCode: this.referralCode
      };
      accountManagementApi
        .setReferral(data)
        .then(res => {
          if (res.errcode === 0) {
            this.successNotify(this.$t('success.invite'));
            this.GET_USERINFO_ACTION();
            this.getMyReferralCode();
          }
        })
        .catch(() => {});
    },
    setCompanyAsReferral() {
      accountManagementApi
        .setCompanyAsReferral()
        .then(res => {
          if (res.errcode === 0) {
            this.successNotify(this.$t('success.invite'));
            this.confirmModalShow = false;
            this.GET_USERINFO_ACTION();
            this.getMyReferralCode();
          }
        })
        .catch(() => {});
    },
    /**
     * 获取我邀请的好友
     */
    getMyReferralData() {
      let pageData = this.pageData;
      accountManagementApi
        .getMyReferral(pageData.current, pageData.size)
        .then(res => {
          let data = res.data;
          if (data) {
            let { pageResult } = data;
            // this.referralPersonsData.kycCount = data.kycCount;
            // this.referralPersonsData.total = pageResult.total;
            // this.config.dataList = pageResult.records;
            // pageData.total = pageResult.total;
            // pageData.pages = pageResult.pages;
            this.config.dataList = data;
          }
        })
        .catch(() => {});
    },
    // 获取邀请奖励规则
    getReferralRules() {
      accountManagementApi.getReferralRules().then(({ data }) => {
        if (data.length > 0) {
          this.referralRules = data[0];
        }
      });
    },
    // 下载二维码图片
    downloadQRCodeImg() {
      let qrcodeCom = this.$refs.qrcodeCom;
      let dom_img = qrcodeCom.$el;
      this.downloadCanvas(dom_img, 'Referral.png', 'image/png');
    },
    showConfirmModal() {
      this.confirmModalShow = true;
    }
  },
  computed: {
    ...mapGetters(['Getter_User_Info']),
    kycStatusText() {
      // 实名认证状态值及描述对应表
      let obj = {
        0: '未实名',
        1: '已实名'
      };
      return obj;
    }
  },
  watch: {
    Getter_User_Info: {
      immediate: true,
      handler(userInfo) {
        let inviteCode = userInfo.invite;
        if (inviteCode) {
          this.inviteUrl = this.baseUrl + '/register?inviteCode=' + inviteCode;
        }
        // const referralCode = userInfo.referral; // my upline
        // if (referralCode) {
        // this.referralCode = referralCode;
        // this.referralSet = true;
        // }
      }
    }
  },
  mounted() {
    // this.drawQrCode();
    this.getMyReferralCode();
    this.getMyReferralData();
    // this.getReferralRules();
  }
};
</script>

<style lang="stylus" scoped>
@import 'invite.scoped.styl';
 .labelInexchangable{
   font-size:13px;
}
</style>
